import React from 'react';
import { Box, styled, Typography, Paper, Avatar, Fab } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';

const StackPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: 'transparent',
    transition: 'ease-in-out .2s',
    width: '97%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const ProfilePanel = props => {
    const {
        check,
        status,
        role,
        displayName,
        firstName,
        lastName,
        schoolLogo,
        profileImage,
        schoolNetwork,
        sk1,
    } = props.data;

    const handleRowClick = () => {
        if (!(status === 'accepted' || status === 'pending')) {
            props.select(props.id, check);
        }
    };
    // console.log('props', props);
    return (
        <StackPaper
            data-cy="network-row"
            onClick={handleRowClick}
            elevation={check ? 5 : status !== '' || role === 'admin' ? 1 : 2}
            sx={{
                backgroundColor:
                    status !== '' && !check ? '' : 'rgba(30,124,168,0.14)',
                '&:hover': {
                    cursor:
                        status === 'accepted' || status === 'pending'
                            ? ''
                            : 'pointer',
                },
            }}
        >
            <Box sx={{ display: 'flex', columnGap: 2, alignItems: 'center' }}>
                <Avatar
                    sx={{ width: 56, height: 56, borderRadius: '3px' }}
                    alt={sk1.startsWith('school_') ? displayName : firstName}
                    src={sk1.startsWith('school_') ? schoolLogo : profileImage}
                />
                <Box sx={{ textAlign: 'left' }}>
                    <Typography
                        data-cy="fullname"
                        sx={{ fontWeight: '600' }}
                        variant="subtitle2"
                    >
                        {sk1.startsWith('school_')
                            ? displayName
                            : `${firstName} ${lastName}`}
                    </Typography>
                    {status !== 'null' && (
                        <Typography variant="subtitle2">
                            {schoolNetwork
                                ? 'Already joined another network.'
                                : status}
                        </Typography>
                    )}
                </Box>
            </Box>

            {role !== 'admin' && status !== '' && (
                <>
                    {check ? (
                        <Fab
                            sx={{ zIndex: 10 }}
                            color="primary"
                            aria-label="checked"
                            size="medium"
                        >
                            <CheckIcon />
                        </Fab>
                    ) : status === 'accepted' || status === 'pending' ? (
                        <></>
                    ) : (
                        <Fab sx={{ zIndex: 10 }} size="medium">
                            <AddIcon color="black" />
                        </Fab>
                    )}
                </>
            )}
        </StackPaper>
    );
};

export default ProfilePanel;
